<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model ref="ModelForm" :rules="FormRules"  :model="model"  :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">

                <a-form-model-item  prop="cTitle" label="灌水名称" class="ant-form-item2">
          <a-input v-model="model.cTitle" placeholder="请输入" :rows="3" />
        </a-form-model-item>

                <a-form-model-item  prop="cCropID"  label="作物" class="ant-form-item2">
                  <a-select v-model="model.cCropID"
                            class="ant-form-item3"
                            @change="onCropIDChange"
                  >
                    <a-select-option v-for="(item,index) in cropNameSelectItems" :value="item.ID">
                      {{item.cDicName}}
                    </a-select-option>
                  </a-select>
        </a-form-model-item>

          <a-form-model-item  prop="cCropGrowthPeriodID"  label="作物生长期" class="ant-form-item2">

            <a-select v-model="model.cCropGrowthPeriodID"
                      class="ant-form-item3"     @change="onCropGrowthPeriodChange"
            >
              <a-select-option v-for="(item,index) in cropGrowthperiodSelectItems" :value="item.ID">
                {{item.cDicName}}
              </a-select-option>
            </a-select>
        </a-form-model-item>

        <a-form-model-item  prop="fArea"  label="灌溉面积" class="ant-form-item2">
          <a-input v-model="model.fArea" placeholder="请输入" :rows="3" />
        </a-form-model-item>
         <a-form-model-item  prop="dStartDate"  label="开始时间" class="ant-form-item2">

           <a-date-picker v-model="model.dStartDate" placeholder="请选择开始时间" />
        </a-form-model-item>
         <a-form-model-item  prop="dEndDate"  label="结束时间" class="ant-form-item2">

           <a-date-picker v-model="model.dEndDate" placeholder="请选择结束时间" />
        </a-form-model-item>
         <a-form-model-item  prop="fQuota"  label="灌水定额" class="ant-form-item2">
          <a-input v-model="model.fQuota" placeholder="请输入" :rows="3" />
        </a-form-model-item>
         <a-form-model-item  prop="iNum"  label="灌水次数" class="ant-form-item2">
          <a-input v-model="model.iNum" placeholder="请输入" :rows="3" />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>


    </a-card>
  </div>
</template>


<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData,_getAllUser } from '@/common/request'

  export default {
    name: 'diseaseForm',
    components: {
      TitleCard
    },
    data() {
      return {
        uploadurl:"",
        fileList:[],
        platformSelectItems:[],
        sceneformSelectItems:[],
        cropNameSelectItems:[],
        farmingContentIDSelectItems :[],
        cropGrowthperiodSelectItems:[],
        userSelectItems:[],
        queryPlatformInfo:{
          cEntID:"",
          keyword:""
        },
        titleMsg1: "生产管理",
        titleMsg2:'灌水计划',
        titleMsg3:'灌水计划',
        titleMsg4:'灌水计划',
        model:{},
        cEntID:"",
        FormRules:{
          cTitle:[
            { required: true, message: '请输入灌水名称', trigger: 'blur' }
          ],
          cCropID: [
            { required: true, message: '请选择作物名称', trigger: 'change' }
          ],
          cCropGrowthPeriodID:[
            { required: true, message: '请选择作物生长期', trigger: 'change' }
          ],

          fArea:[
            { required: true, message: '请输入灌溉面积', trigger: 'blur' }
          ],
          dStartDate:[
            { required: true, message: '请选择开始时间', trigger: 'change' }
          ],
          dEndDate:[
            { required: true, message: '请选择结束时间', trigger: 'change' }
          ],

          fQuota:[
            { required: true, message: '请输入灌水定额', trigger: 'blur' }
          ],
          iNum:[
            { required: true, message: '请输入灌水次数', trigger: 'blur' }
          ],
        }
      }
    },
    mounted () {
      let that=this;
      that.uploadurl=that.$http.defaults.baseURL+"User/Upload";
      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.model.cEntID=that.$store.getters.User.enterprise.ID;

      if (that.$route.params.sceneId){
        // that.model.sceneId=that.$route.params.sceneId;
      }
      if (that.$route.params.ID){
        that.model.ID=that.$route.params.ID;
        that.HandleDetail();
      }

      that.model.cSceneID=that.$store.getters.SCene.ID;
      that.model.cSceneName=that.$store.getters.SCene.cSceneName;
      that.getEntPlatFormData()
      that.getAllUser();
      that.getCropNameData();
      that.getFarmingContentIDData();
      that.getWorkOrder();
      that.getCropGrowthperiodSelectItems();
    },

    methods:{
      onCropGrowthPeriodChange(item){

        this.model.CropGrowthPeriodName=this.cropGrowthperiodSelectItems.filter(s=>s.ID==item)[0].cDicName

      },
      onCropIDChange(item){
        this.model.cCropName=this.cropNameSelectItems.filter(s=>s.ID==item)[0].cDicName;
      },
      uploadchange(e){

        let that=this;

        if (e.file){

          that.fileList.push({
            uid:e.file.response.Id,
            name: e.file.response.Id,
            status: 'done',
            response: '', // custom error message to show
            url: that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+e.file.response.Id,
          })




        }

      },




      platformSelect(){

        this.getSceneData()
      },
      async getAllUser(){

        let that=this
        let res=await _getAllUser(this,this.queryPlatformInfo);

        if(res.code=='200'){
          that.userSelectItems=res.obj.list
        }
      },
      async getWorkOrder(){
        var that=this
        let res=await that.$http.post('EntWorkOrderTask/List',{cSystemCode:'节水灌溉'
        })
        if(res.data.code=='200'){
          that.workOrderSelectItems=res.data.obj.list
        }
      },
      /*获取项目列表*/
      async getEntPlatFormData(){
        var that=this
        let res=await  _getEntPlatFormData(this,this.queryPlatformInfo)


        if(res.data.data.code=="200"){

          that.platformSelectItems=res.data.data.obj.list
          if(that.platformSelectItems.length>0) {
            that.model.cPlatformID=that.platformSelectItems[0].ID

            this.getSceneData()
          }
        }

      },
      async getSceneData(){
        var that=this
        let res=await that.$http.post('EntSceneInfo/List',{cSystemCode:'节水灌溉',cPlatformID:that.model.cPlatformID})

        if(res.data.code=="200"){

          that.sceneformSelectItems=res.data.obj.list

          if(that.sceneformSelectItems.length>0) {
            that.model.cSceneID=that.sceneformSelectItems[0].ID
            that.model.cSceneName=that.sceneformSelectItems[0].cSceneName

          }
        }

      },
      async getCropGrowthperiodSelectItems(){
        var that=this
        let param={dicClassCode: 'CropGrowthPeriod'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code=='200'){
          that.cropGrowthperiodSelectItems=res.data.obj.list
        }
      },
      async getCropNameData(){
        var that=this
        let param={dicClassCode: 'CropName'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code=='200'){
          that.cropNameSelectItems=res.data.obj.list
        }

      },
      async getFarmingContentIDData(){
        var that=this

        let param={dicClassCode: 'FarmingContent'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code='200'){
          that.farmingContentIDSelectItems=res.data.obj.list;
        }


        //  let res=await that.$http.post('FarmingContent/List',{});


      },
      async getKeySecretData(){
        var that=this
        let res=await that.$http.post('HkCamera/GetKeySecretList',{cEntID:that.$store.getters.User.enterprise.ID})

        if(res.data.code=="200"){

          that.AppKeySelectItems=res.data.obj.list

          if(that.AppKeySelectItems.length>0) {
            that.model.AppKey=that.AppKeySelectItems[0].cAppId
            that.model.APPSecret=that.AppKeySelectItems[0].cAppPwd

          }
        }

      },
      sceneformSelect(){
        let that=this;
        that.model.cSceneName=this.sceneformSelectItems.filter(s=>s.ID==that.model.cSceneID)
      },
      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntWLWCropIrrigationPlan/FindById/' + that.model.ID, null)

        if (res.data.code == "200") {
          that.model = res.data.obj.data;
        } else {

        }
      },
      async SaveForms () {
        let that = this;
        let form=that.$refs['ModelForm'];
        form.validate(async valid => {



          that.model.cSystemCode='节水灌溉';


          if (valid) {
            //url


            let res = await that.$http.post('EntWLWCropIrrigationPlan/Save', that.model)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'IrrigationPlanList'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>

